module.exports = __webpack_public_path__ + "static/app-screen-2-f3306a8aab38d98fed355caf6c4dc4ba.png";